<template>
    <section class="funfacts-wrapper pt-70px pb-70px overflow-hidden">
        <div class="container">
            <div class="row align-center">
                <div class="col-md-5">
                    <div class="funfacts-left text-right">
                        <h1 class="section-title">Look At <span>dLab</span> Awesome <span>Fun Facts</span> Measured by the Numbers</h1>
                    </div>
                </div>
                <div class="col-md-7">
                    <fun-facts-box-content />
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import FunFactsBoxContent from '../pieces/FunFactsBoxContent.vue'

export default {
    name: 'FunFacts',
    components: {
        FunFactsBoxContent
    },
    data() {
        return {
        }
    }
}
</script>